import React, { useEffect, useState } from 'react'
import { Match } from '@apis/index'
import Table from '@components/table'
import Status from '@components/status'
import { outlineuser } from '@assets/icons'
import dayjs from 'dayjs'
import IndividualUser from '@pages/admin/user-management/individual-user'
import { useModal } from '@context/ModalContext'

const AdminMatchroom = ({ user }: any) => {
  const { showModal } = useModal()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [totalItems, setTotalItems] = useState(0)
  const [totalPages, setTotalPages] = useState(1)
  const [searchTerm, setSearchTerm] = useState('')

  const fetchJoinedMatches = async (search = '', currentPage = 1) => {
    setLoading(true)
    try {
      const response = await Match.userJoinedMatches({
        id: user.id,
        params: {
          page: currentPage,
          limit: 30,
          isCreatedByAdmin: true,
          ...(search && { search }),
        },
      })

      const items = response?.items || response?.data?.items || []
      setData(items)
      setTotalItems(response?.totalItems || response?.data?.totalItems || 0)
      setTotalPages(response?.totalPages || response?.data?.totalPages || 1)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (user?.id) {
      fetchJoinedMatches(searchTerm, page)
    }
  }, [page, searchTerm, user?.id])

  const columns = [
    { title: 'Join ID', key: 'id' },
    {
      title: 'Player Name',
      key: 'playerName',
      render: (item: any) => (
        <p
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (item?.userId) {
              showModal(<IndividualUser userStateId={item.userId} />, {
                width: 1200,
              })
            }
          }}
        >
          {item.playerName}
        </p>
      ),
    },
    { title: 'Phone No.', key: 'phoneNo' },
    { title: 'Points', key: 'points' },
    { title: 'Position/Rank', key: 'position' },
    { title: 'Kills', key: 'kills' },
    { title: 'Claimed Status', key: 'claimedStatus' },
    {
      title: 'Status',
      key: 'status',
      render: (item: any) => <Status item={item} />,
    },
    {
      title: 'Joined At',
      key: 'createdAt',
      render: (item: any) => (
        <span>{dayjs(item.createdAt).format('YYYY-MM-DD hh:mm A')}</span>
      ),
    },
  ]

  const formattedData = data.map((item: any) => ({
    id: item.id,
    userId: item?.user?.id,
    playerName: item?.user?.name || 'Unknown',
    phoneNo: item?.user?.phoneNo || 'N/A',
    points: item?.points || 0,
    position: item?.infos?.position || item?.infos?.rank || 'N/A',
    kills: item?.infos?.noOfKills ?? 'N/A',
    claimedStatus: item?.claimedStatus || 'N/A',
    status: item?.status || 'N/A',
    createdAt: item?.createdAt,
  }))

  return (
    <div style={{ transform: 'translateY(-20px)' }}>
      <Table
        onSearchChange={(val) => {
          setSearchTerm(val)
          setPage(1)
        }}
        loading={loading}
        onPageChange={setPage}
        totalItems={totalItems}
        totalPages={totalPages}
        pageControlled={page}
        itemsPerPage={30}
        data={formattedData}
        columns={columns}
        text="Admin Matchrooms Joined"
        icon={outlineuser}
        searchKeys={['id', 'playerName']}
        setLimit={() => {}}
        setId={() => {}}
      />
    </div>
  )
}

export default AdminMatchroom
